import React, { Component } from 'react';
import Icon from '../icons/Icon';
import classNames from 'classnames';

import PropTypes from 'prop-types';

class TwoStepButton extends Component {
  static propTypes = {
    onConfirm: PropTypes.func.isRequired,
    buttonText: PropTypes.string,
    confirmText: PropTypes.string,
    cancelText: PropTypes.string,
    iconButton: PropTypes.bool,
    disabled: PropTypes.bool,
  };

  static defaultProps = {
    buttonText: 'Delete',
    confirmText: 'Confirm',
    cancelText: 'Cancel',
    iconButton: false,
  };

  constructor(props) {
    super(props);

    this.state = {
      confirming: false,
    };
  }

  onConfirm = () => {
    if (!this.state.confirming) {
      this.setState({ confirming: true });
    } else {
      this.setState({ confirming: false });
      this.props.onConfirm();
    }
  };

  cancelDelete = () => {
    this.setState({
      confirming: false,
    });
  };

  renderConfirmation() {
    const twoStepClasses = {
      'two-step-button__confirmation': !this.props.iconButton,
      'two-step-button__confirmation--iconButton': this.props.iconButton
    };

    return (
      <div className={classNames(twoStepClasses)}>
        {this.props.iconButton ? (
          <div className="two-step--icon__wrapper">
            <Icon icon="Trash" />
          </div>
        ) : null}
        Are you sure?
        <button className={`${!this.props.iconButton ? 'button button--theme--plain' : ''} two-step--cancel`} onClick={this.cancelDelete}>
          {this.props.cancelText}
        </button>
        <button className={`${!this.props.iconButton ? 'button' : ''} two-step--confirm`} onClick={this.onConfirm}>
          {this.props.confirmText}
        </button>
      </div>
    );
  }

  render() {
    if (this.state.confirming) {
      return this.renderConfirmation();
    }

    return !this.props.iconButton ? (
      <button
        type="button"
        disabled={this.props.disabled}
        size="small"
        className="button button--theme--outline two-step-button"
        onClick={this.onConfirm}
      >
        {this.props.buttonText}
      </button>
    ) : (
      <button className="two-step-button" type="button" disabled={this.props.disabled} size="small" onClick={this.onConfirm}>
        <Icon icon="Trash" />
      </button>
    );
  }
}

export default TwoStepButton;



// WEBPACK FOOTER //
// ./src/common/components/TwoStepButton.js